const Cookies = require('js-cookie');

class TopFlopStorage {

  constructor(init) {
    this.cookie_name  = '_choiz_topflop_sdgs';
    if (init){
      this.reset();
    }
    else {
      this.my_sdgs = this.readCookie();
    }
  }

  reset(){
    this.my_sdgs = [];
    Cookies.set(this.cookie_name, JSON.stringify([]));
  }

  addUUID(uuid){
    this.removeUUID(uuid);
    this.my_sdgs.push(uuid);
    this.updateCookie();
  }

  removeUUID(uuid){
    this.my_sdgs = this.my_sdgs.filter(e => e !== uuid);
    this.updateCookie();
  }

  countUUID(){
    return this.my_sdgs.length;
  }

  updateCookie(){
    Cookies.set(this.cookie_name, JSON.stringify(this.my_sdgs));
  }

  readCookie(){
    try{
      var cookieStore = JSON.parse(Cookies.get(this.cookie_name));
    }
    catch(err){
      var cookieStore = [];
    }
    if (Array.isArray(cookieStore)){
      return cookieStore;
    }
    else {
      return [];
    }
  }

  get_sdgs(){
    return this.my_sdgs;
  }

  // remove temp cookie and store sdgs in user profile cookie and update the user profile if logged in
  send_sdgs(cb){

    var user = new User;
    var self = this;

    user.get_profile(function(current_profile){

      if (current_profile && current_profile.nickname){

        user.set_sdgs(self.my_sdgs, function(status, message){
          if (status == 200) {
            Cookies.remove(self.cookie_name);
          }
          return cb();
        });

      }
      else{

        current_profile['sdgs'] = self.my_sdgs;
        user.set_profile(current_profile, function(){
          Cookies.remove(self.cookie_name);
          return cb();
        });

      }

    });

  }

}

//export default { TopFlopStorage };
//window.TopFlopStorage = TopFlopStorage;

function increaseTopFlopCounter( index ) {
	if ( index < 10 ) {
		jquery( '.xofy .current' ).text( '0'+index );
	} else {
		jquery( '.xofy .current' ).text( index );
	}
}

// function autoHeightAnimate(element, time){
// var curHeight = jquery(element).height(), // Get Default Height
// 	autoHeight = jquery(element).css('height', 'auto').height(); // Get Auto Height
// 	  jquery(element).height(curHeight); // Reset to Default Height
// 	  jquery(element).stop().animate({ height: autoHeight }, time); // Animate to Auto Height
//   }

jquery(document).ready(function(){

  //var max_statements = <%= current_node.fields.statements.count %>;
  var max_statements = jquery('#topflop-ready').data('max-statements');

	if ( max_statements < 10 ) {
  		jquery( '.xofy .total' ).text( '0'+max_statements );
	} else {
		jquery( '.xofy .total' ).text( max_statements );
	}
	jquery( '.xofy .current' ).text( '01' );

  jquery('#topflop-frage-1').show();
  jquery('#topflop-ready').prop('disabled', true);

  var topflopstorage = new TopFlopStorage();

  jquery('#topflop-ready').click(function(){
    var current_counter = topflopstorage.countUUID();
    if (current_counter >0){
      topflopstorage.send_sdgs(function(){
        window.location.href = $('#topflop-ready').data('link-to-result'); //'<%#= current_node.fields.btn_link.path %>';
        return true;
      });
    }
  });

  jquery('.top_flop_flop').on('click', function(self){
    var current_index = self.target.dataset.index;
    var current_uuid  = self.target.dataset.uuid;
	  jquery('.topflop-cta').removeClass('click');

    topflopstorage.removeUUID(current_uuid);

  	if (current_index == max_statements) {
      var current_counter = topflopstorage.countUUID();
      if (current_counter >0){
    		jquery('#topflop-ready').prop('disabled', false).removeClass('disabled').addClass( 'ready' );
    		jquery('.topflop-cta').prop('disabled', true).addClass('disabled');
      }
  	} else {
  		increaseTopFlopCounter( parseInt(current_index)+1 );
  		jquery('#topflop-frage-'+(parseInt(current_index))).hide();
  		jquery('#topflop-frage-'+(parseInt(current_index)+1)).show();
  		jquery('#topflop-frage-'+(parseInt(current_index)+1)).find('.top_flop_flop').addClass('click');
  	}

    return false;
  });

  jquery('.top_flop_top').on('click', function(self){
    var current_index = self.target.dataset.index;
    var current_uuid  = self.target.dataset.uuid;
	  jquery('.topflop-cta').removeClass('click');

    topflopstorage.addUUID(current_uuid);

    if (current_index == max_statements){
      jquery('#topflop-ready').prop('disabled', false).removeClass('disabled').addClass( 'ready' );
      jquery('.topflop-cta').prop('disabled', true).addClass('disabled');
  	} else {
  		increaseTopFlopCounter( parseInt(current_index)+1 );
  		jquery('#topflop-frage-'+(parseInt(current_index))).hide();
  		jquery('#topflop-frage-'+(parseInt(current_index)+1)).show();
  		jquery('#topflop-frage-'+(parseInt(current_index)+1)).find('.top_flop_top').addClass('click');
  	}

    return false;
  });

});
